import React from 'react';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import * as Progress from '../components/Progress';
import Card from '@material-ui/core/Card';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import * as Fab from '../components/Fab';

const useStyles = makeStyles({
    card: {
        maxWidth: 190,
        textAlign: 'center',
        margin: 'auto'
    },
    media: {
        height: 190,

    },
});

export default function Dempgraphics(props) {
    const classes = useStyles();
	const [currentDemoQ, setCurrentDemoQ] = React.useState('1');
	const [questionAnswered, setQuestionAnswered] = React.useState('0');
	const [demoProgressValue, setDemoProgressValue] = React.useState(0);
	const [answeredArr, setAnsweredArr] = React.useState([]);

	const processAnswerArr = (v) => {
		const arr = [];
		if (answeredArr.length === 0) {
			arr.push(v);
		} else {
			answeredArr.forEach((row) => {
				arr.push(row);
			});
			arr.push(v);
		}
		setAnsweredArr(arr)
	}
	const handlePrev = (e) => {
		const current = parseInt(currentDemoQ.substring(0,1));
		setCurrentDemoQ(answeredArr[current - 2].toString());
		const arr = [];
		answeredArr.forEach((row) => {
			arr.push(row);
		});
		arr.pop();
		setAnsweredArr(arr);		
	}

    function handleDemoClick(value) {
        switch (value) {
            case '1_1':
                props.setDirectReports('Individual Contributor')
				setDemoProgressValue((1 / 3) * 100);
                setCurrentDemoQ('2a');
				setQuestionAnswered('1');
				processAnswerArr('1');
				break;
            case '1_2':
                props.setDirectReports('Less than 5')
                setDemoProgressValue((1 / 3) * 100);
				setCurrentDemoQ('2b');
				setQuestionAnswered('1');
				processAnswerArr('1');
				break;
            case '1_3':
                props.setDirectReports('5 - 10')
                setDemoProgressValue((1 / 3) * 100);
				setCurrentDemoQ('2b');
				setQuestionAnswered('1');
				processAnswerArr('1');
                break;
            case '1_4':
                props.setDirectReports('More than 10')
                setDemoProgressValue((1 / 3) * 100);
				setCurrentDemoQ('2b');
				setQuestionAnswered('1');
				processAnswerArr('1');
                break;
            case '2a_1':
                props.setRole('Frontline employee');
                setDemoProgressValue((2 / 3) * 100);
				setCurrentDemoQ('3a');
				setQuestionAnswered('2');
				processAnswerArr('2a');
                break;
            case '2a_2':
                props.setRole('Senior Advisor');
                setDemoProgressValue((2 / 3) * 100);
				setCurrentDemoQ('3a');
				setQuestionAnswered('2');
				processAnswerArr('2a');
                break;
            case '2a_3':
                props.setRole('Coach or Consultant');
                setDemoProgressValue((2 / 3) * 100);
				setCurrentDemoQ('3a');
				setQuestionAnswered('2');
				processAnswerArr('2a');
                break;
            case '2b_1':
                setDemoProgressValue((2 / 3) * 100);
				setCurrentDemoQ('3b');
				setQuestionAnswered('2');
				processAnswerArr('2b');
                break;
            case '2b_2':
                props.setRole('CEO');
                setDemoProgressValue((2 / 3) * 100);
				setCurrentDemoQ('3c');
				setQuestionAnswered('2');
				processAnswerArr('2b');
                break;
            case '2b_3':
                props.setRole('Owner');
                setDemoProgressValue((2 / 3) * 100);
				setCurrentDemoQ('3c');
				setQuestionAnswered('2');
				processAnswerArr('2b');
                break;
            case '2b_4':
                props.setRole('Owner / Partner');
                setDemoProgressValue((2 / 3) * 100);
				setCurrentDemoQ('3c');
				setQuestionAnswered('2');
				processAnswerArr('2b');
                break;
            case '3a_1':
                props.setAspiringManager('Y');
				setDemoProgressValue((3 / 3) * 100);
				setCurrentDemoQ('4');
				setQuestionAnswered('3');
				processAnswerArr('3a');
                break;
            case '3a_2':
                props.setAspiringManager('N');
				setDemoProgressValue((3 / 3) * 100);
				setCurrentDemoQ('4');
				setQuestionAnswered('3');
				processAnswerArr('3a');
                break;
            case '3b_1':
                props.setReportsTo('CEO');
                setDemoProgressValue((3 / 3) * 100);
				setCurrentDemoQ('4');
				setQuestionAnswered('3');
				processAnswerArr('3b');
                break;
            case '3b_2':
                props.setReportsTo('Middle Manager');
                setDemoProgressValue((3 / 3) * 100);
				setCurrentDemoQ('4');
				setQuestionAnswered('3');
				processAnswerArr('3b');
                break;
            case '3c_1':
                props.setOrgSize('Less than 100');
                setDemoProgressValue((3 / 3) * 100);
				setCurrentDemoQ('4');
				setQuestionAnswered('3');
				processAnswerArr('3c');
                break;
            case '3c_2':
                props.setOrgSize('100 - 500');
                setDemoProgressValue((3 / 3) * 100);
				setCurrentDemoQ('4');
				setQuestionAnswered('3');
				processAnswerArr('3c');
                break;
            case '3c_3':
                props.setOrgSize('more than 500');
                setDemoProgressValue((3 / 3) * 100);
				setCurrentDemoQ('4');
				setQuestionAnswered('3');
				processAnswerArr('3c');
                break;
            default:
                setDemoProgressValue((3 / 3) * 100);
				setCurrentDemoQ('4');
				setQuestionAnswered('3');
                break;
        }
        if (value.substring(0, 1) === '3') {
            props.onCompleted();
        }
    }

    return (
        <>
            <div className="instructions">
                <div className="container">
                    <Typography variant="h6">
                        <b>Instructions</b>
                    </Typography>
                    <Typography variant="subtitle1">
                        Tell us a little about yourself so we can better customize your results.  Click each box that best describes to you.
                    </Typography>
                </div>
            </div>
            <div className="container">
                <Progress.BorderLinearProgress variant="determinate" value={demoProgressValue} style={{ textAlign: 'center', marginTop: '20px', marginBottom: '20px' }} color="secondary" />
                <Typography
                    gutterBottom variant="h6"
                    component="h2"
                    className={(currentDemoQ === '1') ? 'fadeIn' : 'fadeOut'}
                    style={{
                        textAlign: 'center',
                        display: currentDemoQ === '1' ? 'block' : 'none'
                    }}>
                    How many direct reports do you have?
                    </Typography>
                <Typography
                    gutterBottom variant="h6"
                    component="h2"
                    className={(currentDemoQ === '2a') ? 'fadeIn' : 'fadeOut'}
                    style={{
                        textAlign: 'center',
                        display: currentDemoQ === '2a' ? 'block' : 'none'
                    }}>
                    Which of the following best describes your role?
                    </Typography>
                <Typography
                    gutterBottom variant="h6"
                    component="h2"
                    className={(currentDemoQ === '3a') ? 'fadeIn' : 'fadeOut'}
                    style={{
                        textAlign: 'center',
                        display: currentDemoQ === '3a' ? 'block' : 'none'
                    }}>
                    Do you hope to one day manage people?
                    </Typography>
                <Typography
                    gutterBottom variant="h6"
                    component="h2"
                    className={(currentDemoQ === '2b') ? 'fadeIn' : 'fadeOut'}
                    style={{
                        textAlign: 'center',
                        display: currentDemoQ === '2b' ? 'block' : 'none'
                    }}>
                    Do you report to anyone?
                    </Typography>
                <Typography
                    gutterBottom variant="h6"
                    component="h2"
                    className={(currentDemoQ === '3b') ? 'fadeIn' : 'fadeOut'}
                    style={{
                        textAlign: 'center',
                        display: currentDemoQ === '3b' ? 'block' : 'none'
                    }}>
                    Which of the following best describes your role?
                    </Typography>
                <Typography
                    gutterBottom variant="h6"
                    component="h2"

                    style={{
                        textAlign: 'center',
                        display: currentDemoQ === '3c' ? 'block' : 'none'
                    }}>
                    How big is your organization?
                </Typography>

                <Grid spacing={3} justify="center" direction="row" container style={{ maxWidth: '1100px', textAlign: 'center', margin: 'auto', paddingTop: '50px', paddingBottom: '10px' }}>
                    <Grid item xs={12} sm={3} style={{ marginBottom: '10px', display: currentDemoQ === '1' ? 'block' : 'none' }}>
                        <Card className={classes.card} onClick={() => handleDemoClick("1_1")}>
                            <CardActionArea>
                                <CardMedia
                                    image="/direct_report.jpeg"
                                    title="No direct reports"
                                    className={classes.media}
                                />
                                <CardContent>
                                    <Typography gutterBottom variant="subtitle1" component="h2">
                                        None
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={3} style={{ marginBottom: '10px', display: currentDemoQ === '1' ? 'block' : 'none' }}>
                        <Card className={classes.card} onClick={() => handleDemoClick("1_2")}>
                            <CardActionArea>
                                <CardMedia
                                    image="/less_than_5.jpeg"
                                    title="Less than 5"
                                    className={classes.media}
                                />
                                <CardContent>
                                    <Typography gutterBottom variant="subtitle1" component="h2">
                                        Less than 5
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={3} style={{ marginBottom: '10px', display: currentDemoQ === '1' ? 'block' : 'none' }}>
                        <Card className={classes.card} onClick={() => handleDemoClick("1_3")}>
                            <CardActionArea>
                                <CardMedia
                                    image="/5_10.jpeg"
                                    title="5 - 10 "
                                    className={classes.media}
                                />
                                <CardContent>
                                    <Typography gutterBottom variant="subtitle1" component="h2">
                                        5 - 10
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={3} style={{ marginBottom: '10px', display: currentDemoQ === '1' ? 'block' : 'none' }}>
                        <Card className={classes.card} onClick={() => handleDemoClick("1_4")}>
                            <CardActionArea>
                                <CardMedia
                                    image="/more_than_10.jpeg"
                                    title="More than 10"
                                    className={classes.media}
                                />
                                <CardContent>
                                    <Typography gutterBottom variant="subtitle1" component="h2">
                                        More than 10
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={3} style={{ marginBottom: '10px', display: currentDemoQ === '2b' ? 'block' : 'none' }}>
                        <Card className={classes.card} onClick={() => handleDemoClick("2b_1")}>
                            <CardActionArea>
                                <CardMedia
                                    image="/reports_to_supervisor.jpeg"
                                    title="My supervisor"
                                    className={classes.media}
                                />
                                <CardContent>
                                    <Typography gutterBottom variant="subtitle1" component="h2">
                                        Yes, my supervisor
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>

                    <Grid item xs={12} sm={3} style={{ marginBottom: '10px', display: currentDemoQ === '2b' ? 'block' : 'none' }}>
                        <Card className={classes.card} onClick={() => handleDemoClick("2b_2")}>
                            <CardActionArea>
                                <CardMedia
                                    image="/reports_to_board.jpeg"
                                    title="Reports to Board"
                                    className={classes.media}
                                />
                                <CardContent>
                                    <Typography gutterBottom variant="subtitle1" component="h2">
                                        Yes, my board
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={3} style={{ marginBottom: '10px', display: currentDemoQ === '2b' ? 'block' : 'none' }}>
                        <Card className={classes.card} onClick={() => handleDemoClick("2b_3")} >
                            <CardActionArea>
                                <CardMedia
                                    image="/reports_to_owner.jpeg"
                                    title="I am an Owner"
                                    className={classes.media}
                                />
                                <CardContent>
                                    <Typography gutterBottom variant="subtitle1" component="h2">
                                        No, I am an owner
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={3} style={{ marginBottom: '10px', display: currentDemoQ === '2b' ? 'block' : 'none' }}>
                        <Card className={classes.card} onClick={() => handleDemoClick("2b_4")}>
                            <CardActionArea>
                                <CardMedia
                                    image="/reports_to_partner.jpeg"
                                    title="I'm in a partnership"
                                    className={classes.media}
                                />
                                <CardContent>
                                    <Typography gutterBottom variant="subtitle1" component="h2">
                                        No, I'm in a partnership
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={3} style={{ marginBottom: '10px', display: currentDemoQ === '3b' ? 'block' : 'none' }}>
                        <Card className={classes.card} onClick={() => handleDemoClick("3b_1")}>
                            <CardActionArea>
                                <CardMedia
                                    image="/reports_to_most_senior_leader.jpeg"
                                    title="Most senior leader"
                                    className={classes.media}
                                />
                                <CardContent>
                                    <Typography gutterBottom variant="subtitle1" component="h2">
										I report to the most senior leader
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={3} style={{ marginBottom: '10px', display: currentDemoQ === '3b' ? 'block' : 'none' }}>
                        <Card className={classes.card} onClick={() => handleDemoClick("3b_2")}>
                            <CardActionArea>
                                <CardMedia
                                    image="/reports_to_levels_below_top.jpeg"
                                    title="Many levels below most senior leader"
                                    className={classes.media}
                                />
                                <CardContent>
                                    <Typography gutterBottom variant="subtitle1" component="h2">
										I am more than one level away from the most senior leader
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={3} style={{ marginBottom: '10px', display: currentDemoQ === '3c' ? 'block' : 'none' }}>
                        <Card className={classes.card} onClick={() => handleDemoClick("3c_1")}>
                            <CardActionArea>
                                <CardMedia
                                    image="/org_size_less_than_100.jpeg"
                                    title="Less than 100"
                                    className={classes.media}
                                />
                                <CardContent>
                                    <Typography gutterBottom variant="subtitle1" component="h2">
                                        Fewer than 100
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={3} style={{ marginBottom: '10px', display: currentDemoQ === '3c' ? 'block' : 'none' }}>
                        <Card className={classes.card} onClick={() => handleDemoClick("3c_2")}>
                            <CardActionArea>
                                <CardMedia
                                    image="/org_size_100_500.jpeg"
                                    title="100 - 500"
                                    className={classes.media}
                                />
                                <CardContent>
                                    <Typography gutterBottom variant="subtitle1" component="h2">
                                        Between 100 and 500
                                     </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={3} style={{ marginBottom: '10px', display: currentDemoQ === '3c' ? 'block' : 'none' }}>
                        <Card className={classes.card} onClick={() => handleDemoClick("3c_3")}>
                            <CardActionArea>
                                <CardMedia
                                    image="/org_size_more_than_500.jpeg"
                                    title="More than 500"
                                    className={classes.media}
                                />
                                <CardContent>
                                    <Typography gutterBottom variant="subtitle1" component="h2">
                                        More than 500
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={3} style={{ marginBottom: '10px', display: currentDemoQ === '3a' ? 'block' : 'none' }}>
                        <Card className={classes.card} onClick={() => handleDemoClick("3a_1")} >
                            <CardActionArea>
                                <CardMedia
                                    image="/thumbs_up.png"
                                    title="Yes"
                                    className={classes.media}
                                />
                                <CardContent>
                                    <Typography gutterBottom variant="subtitle1" component="h2">
                                        Yes, that's the plan
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={3} style={{ marginBottom: '10px', display: currentDemoQ === '3a' ? 'block' : 'none' }}>
                        <Card className={classes.card} onClick={() => handleDemoClick("3a_2")}>
                            <CardActionArea>
                                <CardMedia
                                    image="/thumbs_down.png"
                                    title="No"
                                    className={classes.media}
                                />
                                <CardContent>
                                    <Typography gutterBottom variant="subtitle1" component="h2">
                                        No, I'm good
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={3} style={{ marginBottom: '10px', display: currentDemoQ === '2a' ? 'block' : 'none' }}>
                        <Card className={classes.card} onClick={() => handleDemoClick("2a_1")}>
                            <CardActionArea>
                                <CardMedia
                                    image="/role_frontline_employee.jpeg"
                                    title="Frontline Employee"
                                    className={classes.media}
                                />
                                <CardContent>
                                    <Typography gutterBottom variant="subtitle1" component="h2">
                                        Frontline employee/assistant
                                     </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={3} style={{ marginBottom: '10px', display: currentDemoQ === '2a' ? 'block' : 'none' }}>
                        <Card className={classes.card} onClick={() => handleDemoClick("2a_2")}>
                            <CardActionArea>
                                <CardMedia
                                    image="/reports_to_owner.jpeg"
                                    title="Senior Advisor"
                                    className={classes.media}
                                />
                                <CardContent>
                                    <Typography gutterBottom variant="subtitle1" component="h2">
                                        Senior advisor/board member
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={3} style={{ marginBottom: '10px', display: currentDemoQ === '2a' ? 'block' : 'none' }}>
                        <Card className={classes.card} onClick={() => handleDemoClick("2a_3")}>
                            <CardActionArea>
                                <CardMedia
                                    image="/reports_to_partner.jpeg"
                                    title="Consultant or coach"
                                    className={classes.media}
                                />
                                <CardContent>
                                    <Typography gutterBottom variant="subtitle1" component="h2">
                                        Indepdendent consultant
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                </Grid>
				<div>
					<Fab.BlueFab
						variant="extended"
						size="medium"
						style={{ marginTop: '20px', display: parseInt(currentDemoQ.substring(0,1)) === 1 ? 'none' : 'block' }}
						onClick={handlePrev}
					>
						Previous
					</Fab.BlueFab>
				</div>
            </div>

        </>
    );
};
